<template>
	<div>
		<div
			class="upload-area"
			@dragover.prevent="handleDragOver"
			@drop.prevent="handleFileDrop"
			@dragleave="handleDragLeave"
			@click="triggerFileInput"
			:class="{
				'drag-over': isDragOver,
				'is-error': isError || errorMessage,
			}"
		>
			<div class="mb-2">
				<i class="bi bi-upload icon-upload text-primary"></i>
				<p>{{ fileName }}</p>
				<div class="info-text">{{ fileInfo }}</div>
				<div class="text-danger text-bold" v-if="errorMessage">{{ errorMessage }}</div>
				<div class="progress mt-2" v-if="progress > 0">
					<div
						class="progress-bar"
						:class="{
							'bg-success': progress === 100,
						}"
						role="progressbar"
						:style="{
							width: `${progress}%`,
						}"
						:aria-valuenow="progress"
						aria-valuemin="0"
						aria-valuemax="100"
					>
						{{ progress }}%
					</div>
				</div>
				<div>
					<small>*Nama File akan diubah</small>
				</div>
			</div>
			<input type="file" @change="handleFileSelect" ref="fileInput" style="display: none" />
		</div>
	</div>
</template>

<script>
import mediaApi from '@/api/media';

export default {
	props: {
		isError: {
			type: Boolean,
			default: false,
		},
		prefix: {
			type: String,
			default: '',
		},
		type: {
			type: String,
			default: 'pdf', // pdf, image
		},
	},
	data() {
		return {
			files: [],
			isDragOver: false,
			progress: 0,
			errorMessage: '',
		};
	},
	methods: {
		handleDragOver() {
			this.isDragOver = true;
		},
		handleDragLeave() {
			this.isDragOver = false;
		},
		handleFileDrop(event) {
			this.isDragOver = false;
			const droppedFiles = event.dataTransfer.files;
			this.addFiles(droppedFiles);
		},
		handleFileSelect(event) {
			const selectedFiles = event.target.files;
			this.addFiles(selectedFiles);
		},
		triggerFileInput() {
			this.$refs.fileInput.click();
		},
		addFiles(fileList) {
			this.files = [];
			this.errorMessage = '';
			for (let i = 0; i < fileList.length; i++) {
				this.files.push(fileList[i]);
			}
			this.validateFileType();
		},
		validateFileType() {
			const acceptedImageTypes = ['image/png', 'image/jpg', 'image/jpeg'];
			const file = this.files[0] ?? null;
			if (file) {
				const fileType = file?.type ?? '';
				if (this.isTypePdf && fileType !== 'application/pdf') {
					this.errorMessage = 'Jenis File harus PDF';
					this.files = [];
				} else if (this.isTypeImage && !acceptedImageTypes.includes(fileType)) {
					this.errorMessage = 'Jenis File harus jpg, jpeg atau png';
					this.files = [];
				} else {
					this.upload();
				}
			}
		},
		upload() {
			const file = this.files[0];

			// Check File Size
			const fileSize = file.size / 1000000;
			const isFileSizeTooLarge = fileSize > this.maxUploadSize;

			// Show Notice if size too large
			if (isFileSizeTooLarge) {
				const noticeMessage = `'${file.name}' size is too large (max ${this.maxUploadSize}MB)`;
				this.errorMessage = noticeMessage;
				this.files = [];
				return;
			}

			// Start Upload
			const uploadParams = new FormData();
			if (this.isTypeImage) {
				uploadParams.append('image', file);
			} else {
				uploadParams.append('file', file);
			}
			uploadParams.append('resize', false);
			uploadParams.append('prefix', this.prefix);

			const callback = (response) => {
				const path = response.data;
				const url = `${this.mediaUrlPrefix}/${path}`;
				const uploadedFileName = url.split('/').pop();
				this.$emit('set-url', {
					url,
					size: fileSize,
					name: uploadedFileName,
					original_name: file.name,
					type: this.type,
				});
			};

			const errorCallback = (e) => {
				// eslint-disable-next-line
				console.log(e);
				this.$refs.fileInput.value = '';
				this.files = [];
				this.progress = 0;
				this.errorMessage = 'Terjadi kesalahan saat upload. Mohon coba lagi.';
			};

			const progressCallback = (percentage) => {
				this.progress = percentage;
			};

			if (this.isTypeImage) {
				mediaApi.uploadImage(uploadParams, callback, errorCallback, progressCallback);
			} else {
				mediaApi.uploadShippingLabel(uploadParams, callback, errorCallback, progressCallback);
			}
		},
	},
	computed: {
		fileName() {
			let name = 'Drag & drop files here or click to select files';
			const file = this.files[0] ?? null;
			if (file) {
				name = file?.name ?? '';
			}
			return name;
		},
		isTypePdf() {
			return this.type === 'pdf';
		},
		isTypeImage() {
			return this.type === 'image';
		},
		fileInfo() {
			let info = '';
			if (this.isTypePdf) {
				info = 'Maximum file 15MB dengan format file PDF';
			} else if (this.isTypeImage) {
				info = 'Maximum file 2MB dengan format file jpg, jpeg atau png';
			}
			return info;
		},
		maxUploadSize() {
			let size = 2; // Default 2 MB
			if (this.isTypePdf) {
				size = 15;
			}
			return size;
		},
	},
};
</script>

<style>
.upload-area {
	width: 100%;
	height: 200px;
	border: 2px dashed #ccc;
	display: flex;
	align-items: center;
	justify-content: center;
	text-align: center;
	cursor: pointer;
	transition: background-color 0.3s ease;
}
.is-error {
	border-color: #ed1c24 !important;
}
.drag-over {
	background-color: #e0f7fa;
}
.icon-upload {
	font-size: 35px;
}
.info-text {
	color: #00000073;
	font-size: 14px;
}
</style>
